<template>
    <div class="page justify-start lg:justify-center" v-if="isCompleted">
        <component :is="MountFinishScreen()"></component>
    </div>
    <div class="page" v-else>
        <div class="flex flex-col w-full h-full">
            <div class="question-header" :class="'grad-'+ currentQuiz.color" v-if="currentQuiz !== undefined && currentQuiz !== null">
                <div class="question-header-toolbar">
                    <p class="question-header-title">{{currentQuiz.title}}</p>
                </div>
                <button class="question-header-button hover:animate-pulse" @click="ToQuiz">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                    </svg>
                </button>
                <div class="question-module-card" v-if="currentModule !== undefined && currentModule !== null">
                    <p class="title-sm text-center">Модуль "{{currentModule.title}}"</p>
                    <p class="subtitle">{{currentModule.description}}</p>
                </div>
            </div>
            <div class="w-full flex flex-col items-center justify-center mb-auto" v-if="questions.length > 0">
                <component :is="MountCurrentQuestion()" :key="currentQuestion" ref="currentQuestion"></component>
            </div>
            <p class="subtitle text-center mx-auto" v-else>Вопросы не найдены!</p>
        </div>
    </div>
</template>

<script>
import {markRaw, defineComponent, compile} from "vue"

export default {
    data() {
        return {
            currentQuizID: Number(this.$route.params.id),
            currentModuleID: Number(this.$route.params.modID),
            currentQuiz: null,
            currentModule: null,
            questions: [],
            currentQuestion: 0,
            compiledQuestionTemplate: null,
            isCompleted: false,
        }
    },
    methods: {
        ToQuiz() {
            this.$router.push({name: "QuizModules", params: {id: this.currentQuizID}})
        },
        CopyData(data) {
            return data !== undefined ? JSON.parse(JSON.stringify(data)) : null
        },
        IsStarted() {
            this.$store.commit("updateQuizes")
            let quizesData = this.CopyData(this.$store.state.quizes)

            if (quizesData !== null
                && quizesData[this.currentQuizID] !== undefined 
                && quizesData[this.currentQuizID] !== null 
                && quizesData[this.currentQuizID].quizData !== undefined
                && quizesData[this.currentQuizID].quizData !== null)
                return true

            return false
        },
        MountAnswer(answerID) {
            if (this.questions[this.currentQuestion] == undefined || this.questions[this.currentQuestion] == null) return null

            if (this.questions[this.currentQuestion].answers == undefined || this.questions[this.currentQuestion].answers == null) return null

            let answer = this.questions[this.currentQuestion].answers[answerID]

            if (answer == undefined || answer == null) return null

            return markRaw(defineComponent({
                setup() {
                    return {
                        id: answerID,
                        isCorrect: answer.value > 0,
                    }
                },
                methods: {
                    GetResultHTML() {
                        if (this.isCorrect) {
                            return `
                                <div class=\"answer-result-badge correct\">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                </div>
                            `
                        }

                        return `
                            <div class=\"answer-result-badge wrong\">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                        `
                    },
                    isSelected() {
                        return this.$parent.IsSelected(this.id)
                    },
                    Answer() {
                        this.$parent.Answer(this.id)
                    },
                    ShowResult() {
                        return this.$parent.ShowResult(`ans_${this.id}`)
                    },
                },
                render: compile(`<div @click=\"Answer()\" class=\"answer-container\">${answer.content}<div class=\"answer-result-container\" v-if=\"ShowResult()\" v-html=\"GetResultHTML()\"></div></div>`)
            }))
        },
        MountFinishScreen() {
            let module = this.currentModule
            let currentQuizID = this.currentQuizID
            let currentModuleID = this.currentModuleID
            return markRaw(defineComponent({
                data() {
                    return {
                        module: module,
                        quizData: {},
                        percentage: 0,
                    }
                },
                methods: {
                    GetQuizData() {
                        let quizesData = this.$parent.CopyData(this.$store.state.quizes[currentQuizID])
                        return quizesData.quizData
                    },
                    GetPoints() {
                        let quizesData = this.$parent.CopyData(this.$store.state.quizes[currentQuizID])
                        return quizesData.modules[currentModuleID].points
                    },
                    GetPercentage() {
                        let quizesData = this.$parent.CopyData(this.$store.state.quizes[currentQuizID])
                        return quizesData.modules[currentModuleID].points / module.maxPoints * 100
                    },
                    GoToQuiz() {
                        this.$parent.ToQuiz()
                    }
                },
                mounted() {
                    this.percentage = this.GetPercentage()
                    this.quizData = this.GetQuizData()
                },
                render: compile(this.currentModule.finishPageTemplate)
            }))
        },
        MountCurrentQuestion() {
            let template = this.currentModule.questionTemplate
            let questionCount = this.questions.length
            let currentQuestionID = this.currentQuestion
            let currentQuestion = this.questions[currentQuestionID] || null

            let quizID = this.currentQuizID
            let moduleID = this.currentModuleID

            return markRaw(defineComponent({
                data() {
                    return {
                        quizID: quizID,
                        moduleID: moduleID,
                        currentQuestion: currentQuestionID,
                        title: currentQuestion !== null ? currentQuestion.title : null,
                        content: currentQuestion !== null ? currentQuestion.content : null,
                        descriptionTemplate: currentQuestion !== null ? currentQuestion.descriptionTemplate ?? null : null,
                        answers: currentQuestion !== null ? currentQuestion.answers : [],

                        showResults: {},
                        showDescription: false,
                        
                        questionCount: questionCount
                    }
                },
                methods: {
                    ShowResult(key) {
                        return this.showResults[key] ?? false
                    },
                    EnableShowResults(key) {
                        this.showResults[key] = true
                    },
                    DisableShowResults(key) {
                        this.showResults[key] = false
                    },
                    EnableShowDescription() {
                        if (this.descriptionTemplate == null || this.descriptionTemplate.trim() == "") return
                        this.showDescription = true
                    },
                    DisableShowDescription() {
                        if (this.descriptionTemplate == null || this.descriptionTemplate.trim() == "") return
                        this.showDescription = false
                    },
                    ShowResultsEnabled() {
                        return this.$parent.ShowResultsEnabled()
                    },
                    IsAnswered() {
                        return this.$parent.IsAnswered()
                    },
                    IsSelected(id) {
                        if (!this.IsAnswered()) return false

                        let quizesData = this.$parent.CopyData(this.$store.state.quizes[this.quizID])

                        return quizesData.modules[this.moduleID].questions[this.currentQuestion].includes(id)
                    },
                    IsLast() {
                        return this.$parent.IsLast()
                    },
                    MountAnswer(id) {
                        return this.$parent.MountAnswer(id)
                    },
                    MountDescription() {
                        if (this.descriptionTemplate == null || this.descriptionTemplate.trim() == "") return

                        return markRaw(defineComponent({
                            render: compile(this.descriptionTemplate)
                        }))
                    },
                    Prev() {
                        this.$parent.Prev()
                    },
                    Next() {
                        this.$parent.Next()
                    },
                    Answer(id) {
                        this.$parent.Answer(id)
                    },
                },
                mounted() {
                    if (this.IsAnswered()) {
                        for (var i in this.answers) {
                            var id = Number(i)
                            if (this.IsSelected(id) || this.answers[i].value > 0) this.EnableShowResults(`ans_${id}`)
                        }
                        this.showDescription = true
                    }
                },
                render: compile(template)
            }))
        },
        ShowResultsEnabled() {
            return this.currentModule.showResults
        },
        IsAnswered() {
            let quizesData = this.CopyData(this.$store.state.quizes[this.currentQuizID])
            if (quizesData.modules == undefined || quizesData.modules == null || Object.keys(quizesData.modules).length < 1) return false

            let modules = quizesData.modules

            if (modules[this.currentModuleID] == undefined || modules[this.currentModuleID] == null) return false

            let module = modules[this.currentModuleID]

            if (module.questions == undefined || module.questions == null) return false

            let questions = module.questions

            if (questions[this.currentQuestion] == undefined || questions[this.currentQuestion] == null) return false

            return true
        },
        LoadCurrentQuestion() {
            let quizesData = this.CopyData(this.$store.state.quizes[this.currentQuizID])
            if (quizesData.modules == undefined || quizesData.modules == null || Object.keys(quizesData.modules).length < 1) return

            let modules = quizesData.modules

            if (modules[this.currentModuleID] == undefined || modules[this.currentModuleID] == null) return

            let module = modules[this.currentModuleID]

            if (module.questions == undefined || module.questions == null) return

            let currentQuestionID = 0
            let lastEmptyQuestion = module.questions.length

            for (var i in module.questions) {
                let question = module.questions[i]
                if (question !== null)
                    if (i <= lastEmptyQuestion) {
                        currentQuestionID = Number(i) + 1
                    }
                    else {
                        currentQuestionID = lastEmptyQuestion
                        break
                    }
                        
                if (question == null) lastEmptyQuestion = Number(i)
            }

            this.currentQuestion = currentQuestionID == module.questions.length && module.questions.length > 0 ? currentQuestionID - 1 : currentQuestionID
        },
        IsLast() {
            return this.currentQuestion == this.questions.length - 1
        },
        Prev() {
            if (this.currentQuestion > 0) this.currentQuestion -= 1
        },
        Next() {
            if (this.IsLast() && this.IsAnswered()) {
                let points = 0

                let quizesData = this.CopyData(this.$store.state.quizes)

                for (var i in quizesData[this.currentQuizID].modules[this.currentModuleID].questions) {
                    var questionAnswers = quizesData[this.currentQuizID].modules[this.currentModuleID].questions[i]
                    var question = this.questions[i]

                    for (var j in questionAnswers) {
                        var answerValue = question.answers[questionAnswers[j]].value
                        if (question.multiple) if (answerValue == 0) break

                        points += answerValue
                    }
                        
                }

                points = Math.floor(points)

                quizesData[this.currentQuizID].modules[this.currentModuleID].points = points
                quizesData[this.currentQuizID].modules[this.currentModuleID].questions = []

                this.$store.commit("setQuizes", quizesData)

                this.isCompleted = true
            }

            if (this.IsAnswered())
                if (this.currentQuestion < this.currentModule.questions.length - 1) this.currentQuestion += 1
        },
        Answer(id) {
            if (this.ShowResultsEnabled() && this.IsAnswered()) return
            let quizesData = this.CopyData(this.$store.state.quizes)
            if (quizesData[this.currentQuizID].modules == undefined || quizesData[this.currentQuizID].modules == null) 
                quizesData[this.currentQuizID].modules = {}

            if (quizesData[this.currentQuizID].modules[this.currentModuleID] == undefined || quizesData[this.currentQuizID].modules[this.currentModuleID] == null)
                quizesData[this.currentQuizID].modules[this.currentModuleID] = {questions: []}

            if (quizesData[this.currentQuizID].modules[this.currentModuleID].questions == undefined || quizesData[this.currentQuizID].modules[this.currentModuleID].questions == null)
                quizesData[this.currentQuizID].modules[this.currentModuleID].questions = []
            
            let temp = this.CopyData(quizesData[this.currentQuizID].modules[this.currentModuleID].questions)

            if (quizesData[this.currentQuizID].modules[this.currentModuleID].questions.length < this.currentModule.questions.length)
                for (var i = 0; i < this.currentModule.questions.length - quizesData[this.currentQuizID].modules[this.currentModuleID].questions.length; i++)
                    temp.push(null)

            quizesData[this.currentQuizID].modules[this.currentModuleID].questions = temp

            if (this.currentModule.questions[this.currentQuestion].multiple) {
                if (quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion] == null)
                    quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion] = []
                
                if (quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion].includes(id))
                    quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion].splice(quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion].indexOf(id), 1)
                else
                    quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion].push(id)
            } else {
                quizesData[this.currentQuizID].modules[this.currentModuleID].questions[this.currentQuestion] = [id]
            }

            if (this.ShowResultsEnabled() && !this.IsAnswered()) {
                let correctAnswers = this.currentModule.questions[this.currentQuestion].answers.filter(v => v.value > 0)
                for (var i in correctAnswers) {
                    var correctAnswerIndex = this.currentModule.questions[this.currentQuestion].answers.indexOf(correctAnswers[i])

                    this.$refs.currentQuestion.EnableShowResults(`ans_${correctAnswerIndex}`)
                }

                this.$refs.currentQuestion.EnableShowResults(`ans_${id}`)

                this.$refs.currentQuestion.EnableShowDescription()
            }

            this.$store.commit("setQuizes", quizesData)
        },
        GetAnswerRefs() {
            return this.$refs
        }
    },
    async created() {
        let res = await this.$root.GetQuizes()
        this.currentQuiz = res[Number(this.$route.params.id)]

        if (this.currentQuiz == undefined || this.currentQuiz == null) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 0) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (this.currentQuiz.status == 2) {
            this.$router.push({name: "QuizList"})
            return
        }
        if (!this.IsStarted()) {
            this.$router.push({name: "Quiz", params: {id: this.currentQuizID}})
            return
        }
        if (this.currentQuiz.modules == undefined || this.currentQuiz.modules == null || this.currentQuiz.modules.length < 1) {
            this.$router.push({name: "QuizModules", params: {id: this.currentQuizID}})
            return
        }

        this.currentModule = this.currentQuiz.modules[this.currentModuleID]

        if (this.currentModule == undefined || this.currentModule == null) {
            this.$router.push({name: "QuizModules"})
            return
        }

        this.questions = this.currentModule.questions || []

        this.LoadCurrentQuestion()
    }
}
</script>